'use client';
import { useAuth } from '@clerk/clerk-react';
import { AuthenticatedLayout } from './authenticated-layout';
import { UnauthenticatedLayout } from './unauthenticated-layout';


export function AuthWrapper({ children }: { children: React.ReactNode }) {
  const { isSignedIn, isLoaded } = useAuth();

  return isSignedIn ? (
    <AuthenticatedLayout>{children}</AuthenticatedLayout>
  ) : (
    <UnauthenticatedLayout>{children}</UnauthenticatedLayout>
  );
}
